<script lang="ts">
	import { Asset } from '@atoms';
	import type { AssetWithDescriptionBlockType } from './AssetWithDescriptionBlockQuery';
	import { createViewController, ViewController } from '$lib/actions/animations/ViewController';
	import { EnterOnView } from '$lib/actions/animations/EnterOnView';

	const { data }: { data: AssetWithDescriptionBlockType } = $props();

	createViewController();
</script>

<section use:ViewController>
	{#each data.items as item, i}
		<div class="item">
			<div class="asset" use:EnterOnView={{ delay: i * 0.15 }}>
				<Asset data={item.media} />
			</div>
			<p class="description text:description-medium" use:EnterOnView={{ delay: i * 0.15 + 0.1 }}>
				{item.description}
			</p>
		</div>
	{/each}
</section>

<style lang="scss">
	section {
		@include layoutBlockGrid();
		@include blockPadding;
	}

	.asset {
		aspect-ratio: 1;
		margin-bottom: 22px;
	}

	.item {
		grid-column: span 4;
		border-top: $border;

		padding-top: 22px;
		margin-bottom: 22px;
		margin-top: 42px;
		&:first-child {
			margin-top: 0;
		}

		@include md {
			grid-column: span 3;

			border-top: none;
			padding-top: 0;
			margin-top: 0;
		}
	}
</style>
